export default __webpack_public_path__ + "static/media/KamilaCamillo_02.7c2b9117.jpg";